import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { massForceDeleteClients } from "../../api/apiClients";
import parseError from "../../utils/parseError";

/**
 * Hook لحذف جماعي نهائي للعملاء
 */
export function useForceDeleteAllClients() {
    const queryClient = useQueryClient();

    const {
        mutate: forceDeleteAllClientsMutate,
        isPending,
    } = useMutation({
        mutationFn: massForceDeleteClients,
        onSuccess: (response) => {
            toast.success(response.message || "Force deleted successfully");
            queryClient.invalidateQueries({ queryKey: ["clients"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to force delete clients");
        },
    });

    return {
        forceDeleteAllClientsMutate,
        isPending,
    };
}